module.exports = __webpack_public_path__ + "img/pencil.256c6cae.png";